var map = {
	"./main.jpg": 3019,
	"./user1.jpg": 9820,
	"./user2.jpg": 1803,
	"./user3.jpg": 3758,
	"./user4.jpg": 6229,
	"./user5.jpg": 8360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 630;